import { Invoice } from "../../../entity/Invoice";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { InvoiceDto } from "../../dto/Invoice.Dto";
import { InvoiceMapper } from "../../mapper/InvoiceMapper";

export class WSInvoice {
  private static instance: WSInvoice;

  private constructor() {}

  public static getInstance(): WSInvoice {
    if (!WSInvoice.instance) {
      WSInvoice.instance = new WSInvoice();
    }
    return WSInvoice.instance;
  }

  public async getInvoiceById(id: string): Promise<Invoice> {
    try {
      const url = ROUTES.INVOICES + ROUTES.GET_INVOICE_BY_ID + id;
      const response = await fetchAPI<InvoiceDto>({
        url: url,
        method: Method.GET,
        isAuthenticated: true,
      });

      return InvoiceMapper.toInvoice([response.data])[0];
    } catch (error) {
      throw error;
    }
  }

  public async getInvoicesByStoreId(storeId: string): Promise<Invoice[]> {
    try {
      const url = ROUTES.INVOICES + ROUTES.GET_INVOICES_BY_STORE_ID + storeId;
      const response = await fetchAPI<InvoiceDto[]>({
        url: url,
        method: Method.GET,
        isAuthenticated: true,
      });

      return InvoiceMapper.toInvoice(response.data);
    } catch (error) {
      throw error;
    }
  }

  public async createInvoice(invoice: Invoice): Promise<string> {
    try {
      const url = ROUTES.INVOICES + ROUTES.CREATE_INVOICE;
      const response = await fetchAPI<string>({
        url: url,
        method: Method.POST,
        isAuthenticated: true,
        params: invoice,
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default WSInvoice.getInstance();
